import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import "./NewVersionModal.scss";

interface NewVersionModalProps {
  show: boolean;
  onReload: () => void;
  onLater: () => void;
}

// Shown when a newer frontend build has been deployed while this tab was open
const NewVersionModal = ({ show, onReload, onLater }: NewVersionModalProps) => {
  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      onHide={onLater}
      className="new-version-modal"
      backdropClassName="new-version-backdrop"
      dialogClassName="new-version-dialog"
    >
      <Modal.Body className="text-center p-4">
        <svg className="new-version-icon" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true">
          <circle cx="32" cy="32" r="32" fill="#FDF3D0" />
          <path d="M32 29v13M32 22v1" stroke="#101828" strokeWidth="3.5" strokeLinecap="round" />
        </svg>
        <h4 className="fs-20 fw-700 black-40 mt-3 mb-2">New version available</h4>
        <p className="fs-16 fw-500 black-65 mb-4">
          A new version of this page has been released. Please reload the page to get the latest version.
        </p>
        <div className="d-flex gap-2">
          <Button variant="outline" className="w-100 py-2" onClick={onLater}>
            Later
          </Button>
          <Button variant="secondary" className="w-100 py-2 fw-700" onClick={onReload}>
            Reload
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewVersionModal;
